import { StateCreator } from "zustand";

export interface CommonSlice {
  height: string;
  overflow: string;
  gatesCoordinates: { x: number; y: number };
  setGatesCoordinates: (coordinates: { x: number; y: number }) => void;
  setHeight: (value: string) => void;
  setOverflow: (value: string) => void;
}

export const createCommonSlice: StateCreator<CommonSlice> = set => ({
  height: "100dvh",
  overflow: "auto",
  gatesCoordinates: { x: -10000000000, y: -100000000000 },
  setGatesCoordinates: (gatesCoordinates: { x: number; y: number }) =>
    set(() => ({ gatesCoordinates })),
  setHeight: (height: string) => set(() => ({ height })),
  setOverflow: (overflow: string) => set(() => ({ overflow })),
});
